import { PiWarningCircle } from 'react-icons/pi';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

/**
 * Warning block used for invalid or incomplete widget states.
 */
export const WidgetWarningState: React.FC<{
  title: string;
  issues: string[];
  onAction?: () => void;
  actionLabel?: string;
}> = ({ title, issues, onAction, actionLabel }) => {
  const { t } = useI18n();
  const normalizedIssues =
    issues.length > 0
      ? issues
      : [t('reports.dashboard.setupIssues.reviewConfiguration')];

  return (
    <div className="rounded-xl border border-warning-200 bg-warning-50 px-4 py-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="rounded-full bg-warning-100 p-2 text-warning-800">
          <PiWarningCircle className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1 space-y-2">
          <div className="space-y-1">
            <Text
              as="h4"
              size="small"
              weight="semibold"
              className="text-warning-800"
            >
              {title}
            </Text>
            <Text size="small" className="leading-6 text-warning-800">
              {normalizedIssues[0]}
            </Text>
          </div>
          {normalizedIssues.length > 1 && (
            <div className="space-y-1">
              {normalizedIssues.slice(1).map((issue) => (
                <Text
                  key={issue}
                  size="small"
                  className="leading-6 text-warning-800"
                >
                  {issue}
                </Text>
              ))}
            </div>
          )}
          {onAction && actionLabel ? (
            <div className="pt-1">
              <Button
                size="sm"
                appearance="outline"
                variant="warning"
                onClick={onAction}
              >
                {actionLabel}
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
